/**
 * 等待瀏覽器進入閒置狀態。
 *
 * 用於把非急迫的背景工作（例如線路測速）排到首屏之後，避免與渲染搶主執行緒與網路併發。
 * `requestIdleCallback` 在部分 iOS Safari / WebView 不存在，因此必須有 fallback；
 * 兩條路徑都保證 resolve，呼叫端不需要處理「永遠不回來」的情況。
 */
export const waitForIdle = (timeout = 3000): Promise<void> =>
  new Promise((resolve) => {
    if (typeof requestIdleCallback === 'function') {
      // timeout 確保即使長時間沒有閒置空檔也會被執行，不會無限延後。
      requestIdleCallback(() => resolve(), { timeout })
      return
    }

    setTimeout(resolve, timeout)
  })
